import React from 'react';
import { Container } from './ui/Container';
export function Footer() {
  return <footer className="bg-iris-black border-t border-iris-border pt-16 pb-8" data-id="element-64">
      <Container data-id="element-65">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-16" data-id="element-66">
          <div className="col-span-2 lg:col-span-2" data-id="element-67">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-68">
              <div className="w-6 h-6 bg-iris-green flex items-center justify-center relative overflow-hidden" data-id="element-69">
                <div className="absolute inset-0 border border-iris-black transform rotate-45 scale-110" data-id="element-70"></div>
                <span className="font-display font-bold text-iris-black text-sm relative z-10" data-id="element-71">
                  I
                </span>
              </div>
              <span className="font-display font-bold text-xl tracking-widest text-white" data-id="element-72">
                IRIS INTEL GROUP
              </span>
            </a>
            <p className="text-sm text-iris-muted mb-6 max-w-xs" data-id="element-73">
              Structured request and workflow management for modern intelligence
              operations.
            </p>
            <div className="font-mono text-xs text-iris-muted" data-id="element-74">
              Secure Operations Center
              <br data-id="element-75" />
              Washington, D.C. Area
            </div>
          </div>

          <div data-id="element-76">
            <h4 className="font-mono text-xs text-white uppercase tracking-widest mb-4" data-id="element-77">
              Platform
            </h4>
            <ul className="space-y-3" data-id="element-78">
              {['RFI Intake', 'Workflow Routing', 'Performance Dashboards', 'Audit & Compliance', 'Integrations'].map(link => <li key={link} data-id="element-79">
                  <a href="#" className="text-sm text-iris-muted hover:text-iris-green transition-colors" data-id="element-80">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-81">
            <h4 className="font-mono text-xs text-white uppercase tracking-widest mb-4" data-id="element-82">
              Solutions
            </h4>
            <ul className="space-y-3" data-id="element-83">
              {['Law Enforcement', 'Fusion Centers', 'Federal Agencies', 'Corporate Security'].map(link => <li key={link} data-id="element-84">
                  <a href="#" className="text-sm text-iris-muted hover:text-iris-green transition-colors" data-id="element-85">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-86">
            <h4 className="font-mono text-xs text-white uppercase tracking-widest mb-4" data-id="element-87">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-88">
              {['About Us', 'Available Grants', 'Insights', 'Contact'].map(link => <li key={link} data-id="element-89">
                    <a href="#" className="text-sm text-iris-muted hover:text-iris-green transition-colors" data-id="element-90">
                      {link}
                    </a>
                  </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-iris-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-91">
          <div className="text-xs text-iris-muted font-mono" data-id="element-92">
            &copy; {new Date().getFullYear()} IRIS Intel Group. All rights
            reserved.
          </div>
          <div className="flex items-center gap-6 text-xs text-iris-muted font-mono" data-id="element-93">
            <a href="#" className="hover:text-white transition-colors" data-id="element-94">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-95">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-96">
              Accessibility
            </a>
          </div>
        </div>
      </Container>
    </footer>;
}